import ReactDOM from 'react-dom';
import NewRepFormContainer from '../src/reps/NewRepFormContainer.js';

ReactDOM.render(
  <NewRepFormContainer submitUrl={'/rep_applications'} />
, document.getElementById('app'));
